import { z as z$1 } from "zod";

// src/utils/dateOfBirth.ts
/** Minimum valid customer DOB stored in Firestore (ISO YYYY-MM-DD). */
const MIN_CUSTOMER_DATE_OF_BIRTH = "1900-01-01";
/** Tellescope placeholder when customer DOB is missing (MM-DD-YYYY). */
const TELLESCOPE_DOB_PLACEHOLDER = "01-01-1900";
const DOB_VALIDATION_MESSAGE = "Please enter a valid date of birth";
function maxValidIsoDateUtc() {
	const maxDate = /* @__PURE__ */ new Date();
	maxDate.setUTCDate(maxDate.getUTCDate() + 1);
	return maxDate.toISOString().split("T")[0];
}
const customerDateOfBirthSchema = z$1.preprocess((value) => typeof value === "string" ? value.trim() : value, z$1.string().date({ message: DOB_VALIDATION_MESSAGE }).refine((value) => value >= MIN_CUSTOMER_DATE_OF_BIRTH && value <= maxValidIsoDateUtc(), { message: DOB_VALIDATION_MESSAGE }));
function normalizeDateOfBirth(value) {
	if (typeof value === "string") {
		const trimmed = value.trim();
		return trimmed === "" ? void 0 : trimmed;
	}
	if (value === null || value === void 0) return;
	return value;
}
function isValidDateOfBirth(value) {
	return typeof value === "string" && customerDateOfBirthSchema.safeParse(value).success;
}
/** Converts schema-validated ISO DOB (YYYY-MM-DD) to Tellescope format (MM-DD-YYYY). */
function isoDateOfBirthToTellescopeFormat(isoDate) {
	const [year, month, day] = isoDate.trim().split("-");
	return `${month}-${day}-${year}`;
}
function tellescopeDateOfBirthFromCustomer(dateOfBirth) {
	return isValidDateOfBirth(dateOfBirth) ? isoDateOfBirthToTellescopeFormat(dateOfBirth) : TELLESCOPE_DOB_PLACEHOLDER;
}
function formatDateOfBirthForDisplay(dateOfBirth) {
	const normalized = normalizeDateOfBirth(dateOfBirth);
	if (!isValidDateOfBirth(normalized)) return "Not provided";
	const [year, month, day] = normalized.split("-").map(Number);
	return new Date(Date.UTC(year, month - 1, day)).toLocaleDateString("en-US", {
		year: "numeric",
		month: "long",
		day: "numeric",
		timeZone: "UTC"
	});
}

export { TELLESCOPE_DOB_PLACEHOLDER, customerDateOfBirthSchema, formatDateOfBirthForDisplay, normalizeDateOfBirth, tellescopeDateOfBirthFromCustomer };
//# sourceMappingURL=dateOfBirth.mjs.map